import React, { useState ,useEffect, useCallback, useRef } from "react";
import { FaSearch } from 'react-icons/fa';
import { DateCalendar } from '@mui/x-date-pickers';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { Backdrop, CircularProgress, styled } from "@mui/material";
import ToastMessage from "../../utils/mui/righttoptoast";
import api from "../../api/api";
import { debounce } from 'lodash';
import { useSelector } from "react-redux";
import CustomCalendarHeader from "./CustomCalender";
import { format } from 'date-fns';
import openEmrApi from "../../api/openemrapi";
import { getPracticeId, hasMultipleDepartments } from "../../config/practice";
import { bookingDepartmentId, pickedProvider, pickedSlot } from "../bookingDepartment";
import { useBookingDepartment } from "../useBookingDepartment";
import BookingDepartmentSelect from "../BookingDepartmentSelect";
import { isDateBookable, isSlotFull, isTypeAllowed, slotColorClass, slotRuleError } from "../providerSlotRules";
import { CalendarDays, ChevronDown, Search as SearchIco, X } from "lucide-react";
import "./newappointment.css";
const CustomDateCalendar = styled(DateCalendar)(({ theme }) => ({
  '& .MuiPickersCalendarHeader-label': {
    fontSize: '12px',
  },

  // Style the selected day
  '& .MuiPickersDay-root.Mui-selected': {
    backgroundColor: '#1d2951',
    borderRadius: 4, // Square shape
    outline: 'none',
    boxShadow: 'none',
    border: 'none',
  },

  // Hover and focus styles for selected day
  '& .MuiPickersDay-root.Mui-selected:hover': {
    backgroundColor: '#29386b',
    outline: 'none',
    boxShadow: 'none',
    border: 'none',
  },

  '& .MuiPickersDay-root:focus.Mui-selected': {
    backgroundColor: '#1d2951',
    outline: 'none',
    boxShadow: 'none',
    border: 'none',
  },

  // Remove default focus ring from any day cell
  '& .MuiPickersDay-root:focus': {
    outline: 'none',
    boxShadow: 'none',
  }
}));


/* The calendar's day cell, tinted when the provider has open slots that day.
   Defined once, outside the form: an inline slots.day function is a new
   component type on every render, so any re-render between mousedown and
   mouseup (the scheduler's click-outside handler runs on mousedown) remounted
   the day button and the click never landed - the date did not change. */
const HighlightDay = (props) => {
  const { day, selected, highlightedDates = [], ...other } = props;
  const isHighlighted = highlightedDates.some((d) => dayjs(d).isSame(dayjs(day), "day"));
  return (
    <PickersDay
      {...other}
      day={day}
      selected={selected}
      // the provider has open slots that day
      sx={isHighlighted && !selected ? { backgroundColor: "#e3f3ef", color: "#17695a", fontWeight: 600, "&:hover": { backgroundColor: "#cfeae3" } } : undefined}
    />
  );
};

const NewAppointments = ({ Appointments, setNewAppointments ,selectedAppointment,fetchScheduleData, prefill}) => {
  const [dob, setDob] = useState("");
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const currentDate = useSelector((state) => state.filter.currentDate);
  const[futureSlotsData,setFutureSlotsData]=useState([])
    //  const [selectedProvider, setSelectedProvider] = useState("");
    //   const [selectedAppointmentType, setSelectedAppointmentType] = useState("");
   const [selectedDate, setSelectedDate] = React.useState(dayjs());
   const [note, setNote] = useState("");
   const [provider, setProvider] = useState("");
  const [appointmentType, setAppointmentType] = useState("");
   const [openToast, setOpenToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastSeverity, setToastSeverity] = useState('success');
   const[appointmentname,setAppointmentName]=useState('')
   const[slotsdata,setSlotsData]=useState([])
   const [selectedSlot,setSelectedSlot]=useState('')
  // Morning / afternoon toggle over the time slots (all by default).
  const [slotHalf, setSlotHalf] = useState('all');
  const [providersList,setProviderslist]=useState([])
  const[appointmenttypes,setAppointmentTypes]=useState([])
  const [deleteloading,setDeleteloading]=useState(false)
  const[createloading,setCreateLoading]=useState(false)
  const [providername,setProvidername]=useState('');
  const practiseid = getPracticeId();
  const [fetchedData, setFetchedData] = useState([]);
  const[loading,setLoading]=useState(false)
  const [selectedPatientid, setSelectedPatientid] = useState(null); 
  const suggestionsRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState('');
  // Whole-practice search toggle, same contract as the dashboard search bar.
  // Ref mirrors the state because fetchSearchResults is a []-dep debounce.
  const [searchAllDepts, setSearchAllDepts] = useState(false);
  const allDeptsRef = useRef(false);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [suggestionData, setSuggestions] = useState([]);
  const handleNoteChange = (event) => {
    setNote(event.target.value);
  };
   const userConfig = useSelector((state) => state.userconfig);
  // Department field (owner 10-28): the picked provider's department, staff may
  // change it. Declared after every state it reads (slotsdata, selectedSlot,
  // providersList, provider, selectedDate, userConfig).
  const bookingDept = useBookingDepartment({
    slots: slotsdata,
    selectedSlot,
    providers: providersList,
    providerId: provider,
    visitDate: selectedDate?.format?.('YYYY-MM-DD'),
    requested: userConfig?.config?.departmentid,
  });
  
    const clearAllStates = () => {
        setProvidername('');
        setAppointmentName('');
        setProvider('');
        setAppointmentType('');
        setSelectedSlot('');
        setFirstName('');  // Set first name from fetchedData
    setLastName(''); 
    setEmail('');
    setDob('');
    setSelectedPatientid('')
    setSearchTerm('')
    setFetchedData([])
    };

const highlightedDates = React.useMemo(() => {
  if (!futureSlotsData?.length) return [];

  return futureSlotsData
    .filter(
      (item) =>
        item.is_available === true &&
        item.date &&
        dayjs(item.date).isValid()
    )
    .map((item) => dayjs(item.date));
}, [futureSlotsData]);

// The endpoint reports a window around the selected date, so it can only tell
// us about days inside it. Days it explicitly marks unavailable (the provider
// does not work then, or is blocked) get disabled; days it says nothing about
// stay selectable rather than looking blocked.
const availabilityByDate = React.useMemo(() => {
  const map = new Map();
  (futureSlotsData || []).forEach((item) => {
    if (item?.date && dayjs(item.date).isValid()) {
      map.set(dayjs(item.date).format('YYYY-MM-DD'), item.is_available === true);
    }
  });
  return map;
}, [futureSlotsData]);

const shouldDisableDate = React.useCallback(
  (day) => availabilityByDate.get(dayjs(day).format('YYYY-MM-DD')) === false
    // a weekday the provider's booking rules leave out (7825 only)
    || !isDateBookable(provider, day),
  [availabilityByDate, provider]
);

    const handleSuggestionClick = (item) => {
      if(practiseid==1111){
             setSearchTerm(item.fname+' '+item.lname); // Clear search input
      setShowSuggestions(false); // Hide suggestions
      setSuggestions([]); // Clear suggestions list       
      // fetchDashboardData(item.patientid)

     const selectedPatient = fetchedData.find(patient => patient.id === item.id);

  if (selectedPatient) {
    setFirstName(selectedPatient.fname || '');  // Set first name from fetchedData
    setLastName(selectedPatient.lname || ''); 
    setEmail(selectedPatient.email || '');
    setDob(selectedPatient.DOB || '');
    setSelectedPatientid(selectedPatient.id)
  }
      }else{

         setSearchTerm(item.firstname+' '+item.lastname); // Clear search input
      setShowSuggestions(false); // Hide suggestions
      setSuggestions([]); // Clear suggestions list       
      // fetchDashboardData(item.patientid)

     const selectedPatient = fetchedData.find(patient => patient.patientid === item.patientid);

  if (selectedPatient) {
    setFirstName(selectedPatient.firstname || '');  // Set first name from fetchedData
    setLastName(selectedPatient.lastname || ''); 
    setEmail(selectedPatient.email || '');
    setDob(selectedPatient.dob || '');
    setSelectedPatientid(selectedPatient.patientid)
  }
      }
     

    };

    // useEffect(() => {
    //   if (searchTerm) {
    //     fetchDashboardData(searchTerm);  // Call when the search term changes
    //   }
    // }, [searchTerm]);

    const handleSearch = (e) => {
      const query = e.target.value.toLowerCase();
      setSearchTerm(query);    
      fetchSearchResults(query); // Fetch results based on input
      if (!query) {
        setShowSuggestions(false);
        setSuggestions([]);
      } else {
        setShowSuggestions(true); // Show suggestions if there's input
      }
    };

    const fetchSearchResults = useCallback(
      debounce(async (query) => {
        if (!query) {
          setSuggestions([]);
              return;
        }
        try {
          // const response = await api.post(`/v1/${practiseid}/autocomplete/dssearch`, {
          //   "searchtxt": query
          // });
          let payload = {
      appointmentdate: currentDate,
   searchflag: /^\d+$/.test(query) ? Number(query) : query,
      dashfilter:  null ,
      filterarr: [],
      start: 0,
      limit: 25, // suggestion dropdown — unbounded results made search feel slow
      alldepts: allDeptsRef.current,
    };
    let response;
    if(practiseid==1111){
          response = await openEmrApi.post(
  "/patient/get/",
  {
    apikey: "bmkxeyjfqpwapjqedzj",

    searchflag:/^\d+$/.test(query) ? Number(query) : query,
  },
  {
    headers: {
      "Content-Type": "application/json",
    },
  }
);
    }else{
         response = await api.post(
              `/v1/${practiseid}/appointments/dashboard`, payload
            );
    }

             if (response.status === 200 && response.data) {
            setSuggestions(response.data || []);
               const newData = response.data || [];
       setFetchedData(newData);  
            setShowSuggestions(true);
          }
        } catch (error) {
          console.error('Error fetching search results:', error);
          setShowSuggestions(false);
          setSuggestions([]);
        }
      }, 500),
      [] // Add dependencies
    );
      
    let payload = {
      appointmentdate: currentDate,
      searchflag: null,
      dashfilter:  null ,
      filterarr: [],
      start: 0,
      limit: 0,
    };

    // const fetchDashboardData = async (searchflag) => {
    //   setLoading(true)
    //    if(searchflag){
    //     payload.searchflag=searchflag
    //   }
    //       try {
    //         const response = await api.post(
    //           `/v1/${practiseid}/appointments/dashboard`, payload
    //         );
    //         if (response.status === 200) {
    //           const newData = response.data || [];
    //             setFetchedData(newData);   
    //         }
    //         else{
    //           setFetchedData([])
    //         }
    //       } catch (error) {
    //         console.log('Error fetching dashboard data:', error);
    //         setFetchedData([])
    //       }finally{
    //   setLoading(false)
    //   payload.searchflag=null
      
    //       }
    // };

    const getProviderOpenslots=async(id,dt)=>{
        console.log("provideridOS",id)
        setFutureSlotsData([])
        try {
          const response=await api.post(`/v1/${practiseid}/provider-future-open-slots`,{
          "providerid": id,
          "startdate": dt
          })
          if(response.status===200){
            setFutureSlotsData(response?.data ?? []);
          }else{
            console.log("Unexpected response :");
          }
        } catch (error) {
          console.log(error)
        }
    }


    const getProviders=async()=>{
      try {
        const response=await api.get(`/v1/${practiseid}/providers`)
        if(response.status===200){
          setProviderslist(response.data)
          const providerIds = response.data.map(provider => provider.providerid);
          const appresponse=await api.post(`/v1/${practiseid}/appointment/types`,{
            "providerid":providerIds
        })
      
        if(appresponse.status===200){
           setAppointmentTypes(appresponse.data)
         if(appresponse?.data?.length){
          // setAppointmentType(appresponse?.data[0]?.value)
          // setAppointmentName(appresponse?.data[0]?.appointmenttypeid)
         }
        
        }else{
          setAppointmentTypes([])
        }
        }else{
          setProvider([])
        }
        if(response?.data?.length){
          // setProvider(response?.data[0]?.providerid)
          // setProvidername(response?.data[0]?.providername)
          await getslots(response?.data[0]?.providerid,selectedDate.format('YYYY-MM-DD'))
              }
    
    
      } catch (error) {
        
      }finally{
      }
    }
    
    const getslots=async(id,dt)=>{
      // console.log("id",id)
      // console.log("dt",dt)
        try {
          const response=await api.post(`/v1/${practiseid}/scheduler/daywise-open-slots`,{
          "providerid": id,
          "startdate": dt
          })
          if(response.status===200){
           
            setSlotsData(response.data)
          }else{
            setSlotsData([])
          }
        } catch (error) {
          console.log(error)
        }
    }
    
    const providerChange = async (e) => {
      setProvider(e);

      if (e === "") {
        setProvider('');
        setProvidername('');
        setFutureSlotsData([])
        setSlotsData([]);  // Clear the available slots
        return;  // Do not proceed with fetching slots
      }
      
      console.log("Provider selected:", e);  // Check the value of e
      const selectedProvider = providersList.find((item) => item.providerid == e);
      
      if (selectedProvider) {
   
        setProvidername(selectedProvider?.providername);
        console.log("Provider set:", e);  // Ensure provider is set correctly
        await getProviderOpenslots(e, selectedDate.format("YYYY-MM-DD"));
        getslots(e, selectedDate.format("YYYY-MM-DD"));
      } else {
        console.error("No matching provider found.");
      }
    };
    
    const appointmentChange=(e)=>{
      setAppointmentType(e)
      const selectedAppointmentname=appointmenttypes.find((item)=>item.value==e)
       setAppointmentName(selectedAppointmentname?.appointmenttypeid)
    }
    useEffect(() => {
      if (!appointmentType || !providersList?.length) return;
    
      // run only when provider NOT selected
      if (providername) return;
    
      const apptPrefix = appointmentType.trim().slice(0, 3).toLowerCase();
    
      if (apptPrefix === "art") {
        const matchedProvider = providersList.find((p) => {
          const provPrefix = p?.providername?.trim().slice(0, 3).toLowerCase();
          return provPrefix === "art";   // case-insensitive match
        });
        console.log("Matched provider for ART:", matchedProvider);
    
        if (matchedProvider) {
          setProvider(matchedProvider.providerid);
          setProvidername(matchedProvider.providername);
        }
      }
    }, [appointmentType, providersList]);
      const handleDateChange = async(newDate) => {
        setSelectedDate(newDate);  // Update the selected date state
        // Resolve by id first: `provider` is the value every path actually
        // sets, while `providername` is not always populated alongside it, so
        // a name-only lookup missed and blanked the slots on every date change
        // even though the first date had loaded fine.
        const selectedProvider =
          providersList.find((item) => String(item.providerid) === String(provider)) ||
          providersList.find((item) => item.providername == providername);
        // No provider picked yet → skip; providerid "" 400s both slot
        // endpoints and raises an error toast (QA video 1220731699).
        if (!selectedProvider?.providerid) {
            setSlotsData([]);
            setFutureSlotsData([]);
            return;
        }
        await getslots(String(selectedProvider.providerid),newDate.format('YYYY-MM-DD'))
        await getProviderOpenslots(String(selectedProvider.providerid),newDate.format('YYYY-MM-DD'));
    };
    
      const handleToastClose = () => {
        setOpenToast(false);
    };

    useEffect(()=>{
       getProviders();
    },[])

    // Opened from empty time on the schedule: provider, date and (when it
    // is an open slot) the time come prefilled.
    const pendingSlotRef = useRef(null);
    useEffect(() => {
      if (!Appointments || !prefill || !providersList?.length) return;
      const d = prefill.date ? dayjs(prefill.date) : dayjs();
      setSelectedDate(d);
      pendingSlotRef.current = prefill.time || null;
      const p = providersList.find((x) => String(x.providerid) === String(prefill.providerid));
      if (p) {
        setProvider(String(p.providerid));
        setProvidername(p.providername);
        getProviderOpenslots(String(p.providerid), d.format("YYYY-MM-DD"));
        getslots(String(p.providerid), d.format("YYYY-MM-DD"));
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Appointments, prefill, providersList]);
    useEffect(() => {
      const t = pendingSlotRef.current;
      if (!t || !slotsdata?.length) return;
      const slot = slotsdata.find((x) => x.starttime === t);
      if (slot && !isSlotFull(slot, provider, selectedDate)) setSelectedSlot(t);
      pendingSlotRef.current = null;
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [slotsdata]);




    // console.log('SlectedId',selectedPatientid)

    const createappointment=async(selectedPatientid, { AppointmentNote })=>{
   
        if(!appointmentType){
        setToastMessage('Please Select Appointment Type');
        setToastSeverity('error');
        setOpenToast(true);
        return
        }
      if(!provider){
        setToastMessage('Please Select Provider');
        setToastSeverity('error');
        setOpenToast(true);
        return
      }
      if (!selectedSlot) {
        setToastMessage('Please Select Time Slot');
        setToastSeverity('error');
        setOpenToast(true);
        return;
      }
      // Per-provider booking rules (7825 only; none elsewhere).
      const slotRuleMsg = slotRuleError({ providerid: provider, providername, appointmentType, date: selectedDate, slot: selectedSlot, slots: slotsdata });
      if (slotRuleMsg) {
        setToastMessage(slotRuleMsg);
        setToastSeverity('error');
        setOpenToast(true);
        return;
      }
      try {
        setCreateLoading(true)
          
       let response;
          if (practiseid == 1111) {
  console.log(slotsdata);
  console.log(selectedSlot, 'app');

  // find selected slot index
  const index = slotsdata.findIndex(s => s.starttime === selectedSlot);
  if (index === -1) {
    setCreateLoading(false);
    return;
  }

  // helpers
  const toDate = (date, time) => {
    const [h, m] = time.split(":").map(Number);
    const d = new Date(date);
    d.setHours(h, m, 0);
    return d;
  };

  const formatDateTime = d => {
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");

    let hh = d.getHours();
    const ampm = hh >= 12 ? "PM" : "AM";
    hh = hh % 12 || 12;

    return `${yyyy}-${mm}-${dd} ${hh}:${String(d.getMinutes()).padStart(2, "0")} ${ampm}`;
  };

  // start & end slots
  const startSlot = slotsdata[index];
  const endSlot = slotsdata[index + 1] || startSlot;

  const startDateObj = toDate(startSlot.startdate, startSlot.starttime);
  const endDateObj = toDate(endSlot.startdate, endSlot.starttime);

  // ✅ DEFINE minutesDuration
  const minutesDuration = Math.max(
    (endDateObj - startDateObj) / 60000,
    15
  );

  const startDatetime = formatDateTime(startDateObj);
  const endDateTime = formatDateTime(endDateObj);
console.log(selectedAppointment,'selected appointment')
  response = await openEmrApi.post(`/scheduler/create/`, {
    apikey: "bmkxeyjfqpwapjqedzj",
    patientid: selectedPatientid,
    purpose: appointmentType,
    startDatetime,
    endDateTime,
    minutesDuration,
    purpose_id: appointmentname,
    providerid: provider
  });
}

          else{
  const user=await api.get('/auth/me');
  // The provider's department for this date (CODE visits ask for 3), not the
  // staff member's own; the staff member's department only when no provider
  // rule fires, and never CODE for a provider who is not at CODE that day
  // (schedule/bookingDepartment.js).
  const bookingDepartment = bookingDepartmentId({
    slot: pickedSlot(slotsdata, selectedSlot),
    provider: pickedProvider(providersList, provider),
    providerId: provider,
    visitDate: selectedDate.format('YYYY-MM-DD'),
    requested: user?.config?.departmentid,
  });
         response=await api.post(`/v1/${practiseid}/scheduler/patient/${selectedPatientid}/create_schedule`,{
          // the rule's department, or the one staff picked in the form
          // (+ department_override, which the API books as asked)
          ...bookingDept.fields(bookingDepartment),
          "startdate": selectedDate.format('YYYY-MM-DD'),
          "starttime": selectedSlot,
          "provider": providername,
          "providerid": provider,
          "appointmenttype": appointmentType,
          "appointmenttypeid": appointmentname,
          "notes":AppointmentNote
          
      })

          }
 
      if(response.status==200){
        setToastMessage('Appointment created successfully!');
        setToastSeverity('success');
        setOpenToast(true);

        // Close the modal after appointment is created successfully
        setTimeout(() => {
            setNewAppointments(false); // Close the modal
        }, 1000); // Delay to allow the toast to show

        // Reset all states after successful appointment creation
        clearAllStates();

        // Fetch the updated schedule data
        fetchScheduleData();

        setTimeout(() => {
            setOpenToast(false);
        }, 4000);
      }else{
        setToastMessage('Failed to create schedule. Please try again.');
        setToastSeverity('info');
        setOpenToast(true);
      }
        
      } catch (error) {
        console.log(error)
        setToastMessage('Something Went Wrong');
        setToastSeverity('error');
        setOpenToast(true);
      }finally{
      setCreateLoading(false)
      }
    }
const handleCreateAppointmentClick = () => {
  if (!selectedPatientid) {
    setToastMessage('Please enter patient details');
    setToastSeverity('error');
    setOpenToast(true);
    return;
  }
   if (!provider) {
    setToastMessage('Please select a provider');
    setToastSeverity('error');
    setOpenToast(true);
    return;
  }
     if (!appointmentType) {
    setToastMessage('Please select an appointment type');
    setToastSeverity('error');
    setOpenToast(true);
    return;
  }
   if (!selectedSlot) {
    setToastMessage('Please select a time slot');
    setToastSeverity('error');
    setOpenToast(true);
    return;
  }

  // If both are present, proceed
 createappointment(selectedPatientid, { AppointmentNote: note });
};


  if (!Appointments) return null;

  const handleCloseAppointmentModal=()=>{
    setNewAppointments(false)
    setProvider('')
    setAppointmentType('')
    clearAllStates()
    }

const isProviderMatched = (typeof provider === 'string' && 
    (provider.includes("Leanora") || 
     provider.includes("Reshma") || 
     ['15', '17'].includes(provider))) ||
    (Array.isArray(provider) && provider.some(p => p === "Leanora" || p === "Reshma"));

  if (!isProviderMatched) {
    console.log("No matching provider found.");
  }

  const ready = Boolean(selectedPatientid && provider && appointmentType && selectedSlot);
  const footHint = ready
    ? `${firstName} ${lastName} · ${providername} · ${selectedDate.format("ddd, MMM D")} · ${selectedSlot}`
    : "Fill in the patient, provider, type and time to continue.";

  return (
    <div className="bmna-layer" onClick={handleCloseAppointmentModal}>
      <div className="bmna" role="dialog" aria-label="New appointment" onClick={(e) => e.stopPropagation()}>
        <div className="bmna-head">
          <span className="bmna-head-icon"><CalendarDays /></span>
          <div>
            <div className="bmna-title">New appointment</div>
            <div className="bmna-subtitle">Find the patient, then pick a provider, date and time.</div>
          </div>
          <button type="button" className="bmna-x" onClick={handleCloseAppointmentModal} aria-label="Close">
            <X />
          </button>
        </div>

        <div className="bmna-body">
          {/* 1 Patient */}
          <section className="bmna-pane">
            <div className="bmna-step"><span>1</span>Patient</div>
            <div className="bmna-search-wrap">
              <div className="bmna-search">
                <SearchIco aria-hidden="true" />
                <input
                  type="text"
                  placeholder="Patient name or ID"
                  aria-label="Patient name or ID"
                  value={searchTerm}
                  onChange={handleSearch}
                />
                {/* Whole-practice search toggle (patients move between locations;
                    only a practice with more than one location has it) */}
                {hasMultipleDepartments() && (
                  <label className="bmna-depts" title="Search across all locations">
                    <input
                      type="checkbox"
                      checked={searchAllDepts}
                      onChange={(e) => {
                        allDeptsRef.current = e.target.checked;
                        setSearchAllDepts(e.target.checked);
                        if (searchTerm) fetchSearchResults(searchTerm);
                      }}
                    />
                    <span className="bmna-switch" aria-hidden="true" />
                    All depts
                  </label>
                )}
              </div>
              {showSuggestions && suggestionData.length > 0 && (
                <div ref={suggestionsRef} className="bmna-sugg" role="listbox">
                  {suggestionData.map((item) => {
                    const isOpenEmr = practiseid == 1111;
                    const patientId = isOpenEmr ? item.id : item.patientid;
                    const first = isOpenEmr ? item.fname : item.firstname;
                    const last = isOpenEmr ? item.lname : item.lastname;
                    return (
                      <button key={patientId} type="button" role="option" aria-selected="false" onClick={() => handleSuggestionClick(item)}>
                        <b>{first} {last}</b>
                        <span>#{patientId}</span>
                      </button>
                    );
                  })}
                </div>
              )}
            </div>

            {selectedPatientid ? (
              <div className="bmna-patient">
                <span className="bmna-patient-av">{`${(firstName || "?")[0]}${(lastName || "")[0] || ""}`.toUpperCase()}</span>
                <div className="bmna-patient-text">
                  <b>{firstName} {lastName}</b>
                  <span>
                    #{selectedPatientid}
                    {dob ? ` · DOB ${dayjs(dob).format("MM/DD/YYYY")}` : ""}
                  </span>
                  {email && <span>{email}</span>}
                </div>
              </div>
            ) : null}

            <label className="bmna-label" htmlFor="note">Notes</label>
            <textarea
              id="note"
              rows="3"
              value={note}
              onChange={handleNoteChange}
              className="bmna-notes"
              placeholder="Reason for visit, interpreter, anything the front desk should know"
            />
          </section>

          {/* 2 Appointment */}
          <section className="bmna-pane right">
            <div className="bmna-step"><span>2</span>Appointment</div>
            <div className="bmna-two">
              <div>
                <label className="bmna-label" htmlFor="providers">Provider <i>*</i></label>
                <div className="bmna-select">
                  <select id="providers" value={provider || ""} onChange={(e) => providerChange(e.target.value)}>
                    <option value="">Select Provider</option>
                    {providersList.map((providerItem) => (
                      <option key={providerItem.providerid} value={providerItem.providerid}>
                        {providerItem.providername}
                      </option>
                    ))}
                  </select>
                  <ChevronDown aria-hidden="true" />
                </div>
              </div>
              <div>
                <label className="bmna-label" htmlFor="appointmentType">Appointment type <i>*</i></label>
                <div className="bmna-select">
                  <select id="appointmentType" value={appointmentType} onChange={(e) => appointmentChange(e.target.value)}>
                    <option value="">Select Appointment Type</option>
                    {appointmenttypes.filter((type) => isTypeAllowed(provider, type?.value, selectedDate)).map((type, index) => (
                      <option key={index} value={type?.value}>
                        {type?.value}
                      </option>
                    ))}
                  </select>
                  <ChevronDown aria-hidden="true" />
                </div>
              </div>
            </div>

            {/* Department (owner 10-28): pre-selected from the picked provider
                (Dr. Adupa -> CODE from 2026-11-01, Dr. Malik -> Frisco), staff
                may change it; the submit sends department_override then. Only
                a practice with more than one department renders it. */}
            <BookingDepartmentSelect
              value={bookingDept.departmentId}
              ruleValue={bookingDept.ruleDepartment}
              onChange={bookingDept.setPicked}
              wrapperClassName="bmna-dept"
              labelClassName="bmna-label"
              className=""
            />

            <div className="bmna-label">Date</div>
            <div className="bmna-cal">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <CustomDateCalendar
                  value={selectedDate}
                  onChange={handleDateChange}
                  minDate={dayjs()}
                  shouldDisableDate={shouldDisableDate}
                  dayOfWeekFormatter={(date) => date.format("dd")}
                  slots={{ calendarHeader: CustomCalendarHeader, day: HighlightDay }}
                  slotProps={{ day: { highlightedDates } }}
                />
              </LocalizationProvider>
            </div>

            <div className="bmna-time-head">
              <div className="bmna-label">Time · {selectedDate.format("ddd, MMM D")}</div>
              {provider && slotsdata.length > 0 && (
                <div className="bmna-half" role="tablist" aria-label="Time of day">
                  {[
                    ["all", "All", slotsdata.length],
                    ["am", "AM", slotsdata.filter((x) => parseInt(x.starttime, 10) < 12).length],
                    ["pm", "PM", slotsdata.filter((x) => parseInt(x.starttime, 10) >= 12).length],
                  ].map(([k, label, n]) => (
                    <button
                      key={k}
                      type="button"
                      role="tab"
                      aria-selected={slotHalf === k}
                      className={slotHalf === k ? "on" : ""}
                      onClick={() => setSlotHalf(k)}
                    >
                      {label}
                      <span>{n}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
            {provider && slotsdata.length > 0 && slotHalf !== "all" &&
            !slotsdata.some((x) => (parseInt(x.starttime, 10) < 12) === (slotHalf === "am")) ? (
              <div className="bmna-slots-empty">No {slotHalf === "am" ? "morning" : "afternoon"} slots on this day.</div>
            ) : provider && slotsdata.length > 0 ? (
              <div className="bmna-slots">
                {slotsdata
                  .filter((x) => slotHalf === "all" || (parseInt(x.starttime, 10) < 12) === (slotHalf === "am"))
                  .map((slot) => (
                  <button
                    type="button"
                    onClick={() => setSelectedSlot(slot.starttime)}
                    key={slot.starttime}
                    className={`bmna-slot ${slotColorClass(slot.appointment_count, provider, selectedDate)}${selectedSlot === slot.starttime ? " on" : ""}`}
                    disabled={isSlotFull(slot, provider, selectedDate)}
                  >
                    {slot.starttime}
                    {slot.appointment_count > 0 && <span className="bmna-slot-n">({slot.appointment_count})</span>}
                  </button>
                ))}
              </div>
            ) : provider && slotsdata.length === 0 ? (
              <div className="bmna-slots-empty">No open slots for this provider on this day.</div>
            ) : (
              <div className="bmna-slots-empty">Choose a provider to see open times.</div>
            )}
          </section>
        </div>

        <div className="bmna-foot">
          <span className={`bmna-hint${ready ? " ready" : ""}`}>{footHint}</span>
          <button type="button" className="bmna-btn" onClick={handleCloseAppointmentModal}>
            Cancel
          </button>
          <button type="button" className="bmna-btn primary" onClick={handleCreateAppointmentClick}>
            Create appointment
          </button>
        </div>
      </div>
      <Backdrop
        sx={{
          color: "secondary.main",
          backgroundColor: "rgba(255, 255, 255, 0.5)",
          zIndex: (theme) => theme.zIndex.modal + 10,
        }}
        open={createloading}
      >
        <CircularProgress color="secondary" />
      </Backdrop>

      <ToastMessage message={toastMessage} severity={toastSeverity} open={openToast} handleClose={handleToastClose} />
    </div>
  );
};

export default NewAppointments;
